export const loginUrl = "leadership/auth/login";
export const logOutUrl = "leadership/auth/logout";
export const generateAuthUrl = "leadership/auth/generate-code";
export const authCallBack = "leadership/auth/callback";
export const getNewTokens = "leadership/auth/new-token";
// Dashboard — post-login bootstrap config (service lines, branches, payors,
// dashboards/categories, data-refresh timestamp) for the new DayLight UI.
export const getDashboardConfig = "dashboard/config";
// Dashboard — the Metrics Guide dictionary for one service line (definitions
// only: descriptions, formulas, drill grain and related metrics — no values).
export const getMetricDefinitions = "dashboard/metric-definitions";
// Dashboard — metric values for one dashboard (cards, trend, per-branch).
export const getDashboardMetrics = "dashboard/dashboard-metric";
// Dashboard — related metrics for the Trends-View Relationship section.
export const getMetricRelations = "dashboard/metric-relations";
// Every drill-down summary — the "By …" tabs and the "More ▾" breakdowns — one
// metric grouped by any dimension (`GetMetricSummaryForDateRange`, `summarizeBy`
// in the body).
export const getMetricSummary = "dashboard/metric-summary";
// Patient Notifications' "Avg Attainment by Discipline" graph. Always returns
// the four ETA notification metrics, so it is NOT interchangeable with the
// drill-down summary above.
export const getMetricDisciplineNotifications = "dashboard/metric-discipline-notifications";
export const getClinicianDetails = "dashboard/clinician-details";
export const getBranchDetails = "dashboard/branch-details";
export const getMetricBranchTrend = "dashboard/metric-branch-trend";
export const saveCustomView = "dashboard/save-custom-view";
// Dashboard — persist the filter selection when a cached metrics response meant
// the metrics SP (which normally saves it) never ran. See `useSaveUserFilter`.
export const saveUserFilter = "dashboard/save-user-filter";
// Dashboard — the user's saved custom views for the dashboard being opened.
export const getCustomViews = "dashboard/custom-views";
export const deleteCustomView = "dashboard/delete-custom-view";
export const getAllMetricInterval = "all-metric/interval";
export const getMetricDrillDown = "all-metric/drill-down";

// Charlie — the Administrator Daily Brief. One call returns both halves of the
// screen: the brief's suggestions and My Tasks (`[Charlie].[GetTasks]`).
export const getCharlieFeed = "charlie/feed";

// Charlie writes. A decision MOVES an existing signal task between the feed's
// two lists — nothing is ever created — so these all address a SignalTaskID.
export const postCharlieTaskStatus = "charlie/task/status";
export const postCharlieTaskNote = "charlie/task/note";
export const postCharlieTaskReschedule = "charlie/task/reschedule";

// The records behind ONE signal task (`[Charlie].[GetSignalDrillDown]`) — what
// "Open Orders" / "Open Patients" opens. Fetched on the click: most tasks are
// never drilled into, and the columns differ per signal.
export const getCharlieDrillDown = "charlie/drilldown";
